import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackHover } from './tracking';
import { Actual, TooltipContent, Warning } from '../../components/PriceRelevance';
import { getPriceRelevance } from '../../selectors/newObject/priceRelevance';
import { EType } from '../../types/priceRelevance';

export const PriceRelevance = () => {
  const tooltip = useSelector(getPriceRelevance);

  if (!tooltip) {
    return null;
  }

  if (tooltip.type === EType.Warning) {
    return (
      <Warning
        label={tooltip.label}
        title={tooltip.title}
        description={<TooltipContent description={tooltip.description} onVisible={trackHover} />}
      />
    );
  }

  return (
    <Actual
      label={tooltip.label}
      title={tooltip.title}
      description={<TooltipContent description={tooltip.description} onVisible={trackHover} />}
    />
  );
};

PriceRelevance.displayName = 'PriceRelevance';
